<template>
  <pop-over position="bottom-center" class="filter-popover" size="300px">
    <div slot="clickTrigger">
      <button class="mds-button mds-button--flat filter-title" type="button">
        <span class="mds-button__text">{{ title }}</span>
        <svg class="mds-icon mds-button__icon mds-button__icon--right" aria-hidden="true">
          <use xlink:href="static/mds/icons/mds.svg#caret-down"></use>
        </svg>
      </button>
    </div>
    <span slot="header">{{ subtitle }}</span>
    <div slot>
      <div class="single-list">
        <ul class="mds-list-group">
          <li class="mds-list-group__item" v-for="(item, index) in optionsList" :key="index">
            <a href="#" class="mds-list-group__link" @click="handleClick(item)">
              <span class="mds-list-group__item-text">{{ item.displayName }})</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </pop-over>
</template>
<script>
import PopOver from '@/components/atoms/SingleUsePopOver';

export default {
  name: 'simpleLineupProductList',
  components: {
    'pop-over': PopOver,
  },
  props: ['optionsList', 'title', 'subtitle', 'disabled', 'displayName'],
  methods: {
    handleClick(item) {
      this.$emit('clickItem', item);
    },
  },
};
</script>
<style lang="scss">
.filter-popover {
  z-index: 299;
  max-height: 400px;
  border: solid 1px $mds-color-neutral-50;
  margin-left: $mds-space-inset-2-x;
  button {
    padding-left: $mds-space-inset-1-and-a-half-x;
    padding-right: $mds-space-inset-1-and-a-half-x;
  }
}
.single-list {
  max-height: 300px;
  overflow: auto;
}
</style>
